import { Badge, type BadgeProps, Button, type ButtonProps } from '@radix-ui/themes';
import styled, { css } from 'styled-components';
import Icon, { type IconProps } from '../Icon';

interface OnoButtonProps extends ButtonProps {
  error?: boolean;
  isValueSet?: boolean;
  noHover?: boolean;
}

export const OnoButton = styled(Button)<OnoButtonProps>`
  ${({ error }) =>
    error &&
    css`
      border: 1px solid var(--error-11);
    `}

  &:where([data-disabled]) {
    background-color: var(--neutral-a2);
    box-shadow: inset 0 0 0 1px var(--neutral-a6);

    ${props =>
      props.isValueSet &&
      css`
        background-color: var(--neutral-a3);
      `}
  }
  ${props =>
    props.variant !== 'ghost' &&
    !props.noHover &&
    css`
      &:not([data-disabled]) {
        &:hover,
        &:active {
          box-shadow: inset 0 0 0 1px var(--neutral-a8);
        }
      }
    `}
`;

interface OnoCursorPointerCSSProps {
  disabled?: boolean;
}

const cursorPointerCSS = css<OnoCursorPointerCSSProps>`
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
`;

export const OnoBadge = styled(Badge)<OnoCursorPointerCSSProps & BadgeProps>`
  ${cursorPointerCSS}
`;

export const OnoIcon = styled(Icon)<OnoCursorPointerCSSProps & IconProps>`
  ${cursorPointerCSS}
  ${props =>
    props.hoveredColor &&
    css`
      &:hover {
        background-color: ${props.hoveredColor};
        border-radius: 4px;
      }
    `}
`;
